import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  /**
   * Wrapper for the photos section. The child band is full-bleed via its
   * own breakout (`CoachPhotos.testimonialsWrapper`) and supplies its own
   * canonical vertical padding, so this wrapper deliberately has no
   * paddingTop / paddingBottom — extra space here would show as a gray
   * strip of the page background between the navy hero and the white
   * full-bleed photos band.
   */
  /**
   * Full-width wrapper for the photos / testimonial bands on the coach
   * profile. Each child section supplies its own full-bleed surface and
   * canonical 1200px inset (`coach-photos.photosSectionContainer`,
   * etc.) — this wrapper must stay viewport-wide so the breakout math in
   * those children lines up with the other
   * post-bio bands. Do not reuse this class for `CoachOfferingPrograms`;
   * that section has its own centered inset in `coach-offering-programs.styles`.
   */
  offeringsRoot: {
    width: '100%',
    margin: 0,
  },
  offeringsOverline: {
    color: theme.palette.primary.dark,
    fontSize: '12px',
    fontFamily: 'Nunito Sans',
    letterSpacing: '1px',
  },
  paginationNumber: {
    fontFamily: 'Source Serif Pro',
    fontSize: '18px',
    fontWeight: '700',
    letterSpacing: '0.02em',
    textAlign: 'center',
    textDecoration: 'none',
    color: theme.palette.grey.dark,
    padding: theme.spacing(1),
    width: '40px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '100%',
  },
  eventsWrapper: {
    paddingBottom: '64px',
    '& .slick-slide': {
      padding: '30px 0px',
      '& > div': {
        paddingLeft: '12px',
        paddingRight: '12px',
      },
      '& > div:first-child': {
        paddingBottom: '28px',
      },
    },
    '& .slick-list': {
      margin: '0 auto',
      width: 'calc( 100% + 28px)',
      marginLeft: '-14px',
    },
    '& .slick-dots': {
      bottom: '24px',
    },
    '& .slick-dots li': {
      width: '40px',
      height: '40px',
      margin: '0',
    },
    '& .slick-active > a': {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.primary.contrastText,
    },
    '& .slick-next': {
      display: 'none!important',
    },
    '& .slick-prev': {
      display: 'none!important',
    },
  },
  eventsWrapperCenter: {
    '& .slick-slide:first-child > div': {
      float: 'right',
    },
    '& .slick-slide > div': {
      width: '410px',
    },
  },
  singleEventWrapperCenter: {
    '& .slick-slide > div': {
      width: '410px',
      margin: '0 auto',
    },
  },
}))

export default useStyles
